import React, { useState } from 'react';

const ApiKeyTip = ({ isDarkMode = false }) => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div className={`relative rounded-lg p-4 mb-6 border ${
      isDarkMode 
        ? 'bg-blue-900/20 border-blue-700 text-blue-200' 
        : 'bg-blue-50 border-blue-200 text-blue-800'
    }`}>
      <div className="flex items-start">
        <div className="flex-shrink-0">
          <svg className="h-5 w-5 text-blue-400" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
          </svg>
        </div>
        <div className="ml-3 flex-1">
          <h3 className={`text-sm font-medium ${isDarkMode ? 'text-blue-200' : 'text-blue-800'}`}>
            Need an API Key?
          </h3>
          <div className={`mt-2 text-sm ${isDarkMode ? 'text-blue-300' : 'text-blue-700'}`}>
            <p>
              To use the Xomali API, you'll need an API key. You can create and manage your API keys from your account dashboard.
            </p>
            <a
              href="https://account.fluxuro.ai/account"
              target="_blank"
              rel="noopener noreferrer"
              className={`inline-flex items-center mt-3 px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                isDarkMode 
                  ? 'bg-blue-600 hover:bg-blue-700 text-white' 
                  : 'bg-blue-600 hover:bg-blue-700 text-white'
              }`}
            >
              <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
              </svg>
              Get Your API Key
            </a>
          </div>
        </div>
        <button
          onClick={() => setIsVisible(false)}
          className={`ml-3 flex-shrink-0 ${
            isDarkMode ? 'text-blue-300 hover:text-blue-200' : 'text-blue-400 hover:text-blue-500'
          }`}
        >
          <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default ApiKeyTip;
